/* Modalco cart page controller v2
   - every cart change runs as ONE serialized transaction:
     mutate -> read cart -> gift sync (modalco-plus) -> single render -> ladder
   - same-variant lines are merged server-side (main-cart-items.liquid), so no split rows ever appear
   - optimistic quantity: the number changes instantly, prices refresh once when Shopify has calculated */
(function () {
  var P = location.pathname;
  if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(P)) return;
  if (window.mcCartTx) return;
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var T = EN
    ? { clear: 'Clear cart', ask: 'Remove all items from your cart?', no: 'Cancel', yes: 'Yes, clear', err: 'Something went wrong, please try again.', stock: 'Not enough stock for more of this item.', upd: 'Cart updated' }
    : { clear: 'Sepeti temizle', ask: 'Sepetteki tüm ürünler kaldırılsın mı?', no: 'Vazgeç', yes: 'Evet, temizle', err: 'Bir sorun oluştu, lütfen tekrar deneyin.', stock: 'Bu üründen daha fazla stok bulunmuyor.', upd: 'Sepet güncellendi' };
  var ICON = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Satır stilleri (2026-10-13) modalco-cro.css "11) Sepet sayfası kayma önleme" bölümüne taşındı: JS çalışmadan ilk çizimde hazır olsunlar, satırlar kaymasın. */

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  /* every network call has a hard timeout: a stalled mobile request must never freeze the cart */
  function TF(u, o, ms) {
    o = o || {};
    var ctl = window.AbortController ? new AbortController() : null, tm;
    if (ctl) o.signal = ctl.signal;
    var p = fetch(u, o);
    var t = new Promise(function (_, rej) {
      tm = setTimeout(function () { try { ctl && ctl.abort(); } catch (e) {} var er = new Error('timeout'); er.timeout = true; rej(er); }, ms || TF.ms);
    });
    return Promise.race([p, t]).then(function (r) { clearTimeout(tm); return r; }, function (e) { clearTimeout(tm); throw e; });
  }
  TF.ms = 6000;
  function J(u, o) {
    o = o || {};
    var h = { Accept: 'application/json' };
    if (o.body) h['Content-Type'] = 'application/json';
    return TF(u, { method: o.method || 'GET', credentials: 'same-origin', headers: h, body: o.body }).then(function (r) {
      return r.text().then(function (t) {
        var j = {};
        try { j = JSON.parse(t); } catch (e) {}
        if (!r.ok) { var er = new Error(j.description || j.message || 'HTTP ' + r.status); er.status = r.status; throw er; }
        return j;
      });
    });
  }
  /* modalco-plus'ın paylaşılan sepet deposu: aynı anda gelen okumalar tek isteğe iner, mutasyon yanıtları ve
     sayfaya gömülü sepet verisi yeniden kullanılır. force=true her zaman sunucudan okur (hata/doğrulama yolları). */
  function getCart(force) { return window.mcCartGet ? window.mcCartGet(!!force) : J('/cart.js?mc=' + Date.now()); }
  function sig(c) {
    return c.items.map(function (i) { return i.key + ':' + i.quantity + ':' + i.final_line_price; }).join('|') + '#' + c.total_price + '#' + c.item_count;
  }
  function visibleProps(it) {
    var p = it.properties || {};
    return Object.keys(p).some(function (k) { return k.charAt(0) !== '_' && p[k]; });
  }
  /* /cart/update.js returns cart-level discounts as {amount, discount_application}; /cart.js returns them flat */
  function norm(c) {
    if (c && c.cart_level_discount_applications) {
      c.cart_level_discount_applications = c.cart_level_discount_applications.map(function (d) {
        if (!d || !d.discount_application) return d;
        var a = d.discount_application, o = {};
        for (var k in a) o[k] = a[k];
        if (o.total_allocated_amount == null) o.total_allocated_amount = d.amount;
        return o;
      });
    }
    return c;
  }
  function isGift(it) { return !!(it.properties && it.properties._hediye); }

  /* ---------- rendering ---------- */
  function sectionIds() {
    var mi = document.getElementById('main-cart-items'), mf = document.getElementById('main-cart-footer');
    return { items: mi && mi.dataset.id, foot: mf && mf.dataset.id };
  }
  function innerOf(html, sel) {
    var d = new DOMParser().parseFromString(html, 'text/html'), el = d.querySelector(sel);
    return el ? el.innerHTML : null;
  }
  function swapDoc(doc) {
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var a = document.getElementById(id), b = doc.getElementById(id);
      if (a && b) { a.innerHTML = b.innerHTML; a.className = b.className; }
    });
    var ci = $('cart-items'), nci = doc.querySelector('cart-items');
    if (ci && nci) ci.className = nci.className;
    ['cart-icon-bubble', 'cart-live-region-text'].forEach(function (id) {
      var a = document.getElementById(id), b = doc.getElementById(id);
      if (a && b) a.innerHTML = b.innerHTML;
    });
  }
  function renderPage() {
    return TF(P + '?mc=' + Date.now(), { credentials: 'same-origin', headers: { Accept: 'text/html' } }, 10000)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (h) { swapDoc(new DOMParser().parseFromString(h, 'text/html')); });
  }
  function secList() {
    var I = sectionIds();
    return [I.items, I.foot, 'cart-icon-bubble', 'cart-live-region-text'].filter(Boolean);
  }
  function render(c, pre) {
    var ae = document.activeElement, fr = ae && ae.closest && ae.closest('tr[data-mc-gk]'), fgk = fr && fr.getAttribute('data-mc-gk'), fsel = ae && ae.classList && (ae.classList.contains('mc-qty__del') ? '.mc-qty__del' : (ae.getAttribute('data-d') ? '.mc-qty__btn[data-d="' + ae.getAttribute('data-d') + '"]' : null));
    var wasEmpty = !!($('cart-items') && $('cart-items').classList.contains('is-empty'));
    return render0(c, pre).then(function (x) {
      if (fgk && fsel && !document.activeElement.closest('tr[data-mc-gk]')) {
        var nr = rowByGk(fgk), el = nr && $(fsel, nr);
        if (el && !el.disabled) el.focus({ preventScroll: true });
        else { var t = nr ? $('.mc-qty__btn,.mc-qty__del', nr) : $('#main-cart-items .mc-qty__btn,.title-wrapper-with-link h1'); if (t) { if (t.tagName === 'H1') t.setAttribute('tabindex', '-1'); t.focus({ preventScroll: true }); } }
      }
      if (!wasEmpty && c && c.item_count === 0) { try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, 0); } }
      return x;
    });
  }
  function render0(c, pre) {
    var I = sectionIds();
    if (!I.items) return renderPage();
    var secs = secList();
    var got = pre && pre[I.items] ? Promise.resolve(pre) : TF('/cart?sections=' + secs.join(',') + '&mc=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    return got
      .then(function (S) {
        var hi = S[I.items] && innerOf(S[I.items], '.js-contents');
        var hf = I.foot && S[I.foot] && innerOf(S[I.foot], '.js-contents');
        if (hi == null) return renderPage();
        var mi = $('#main-cart-items .js-contents');
        if (mi) mi.innerHTML = hi;
        var mf = $('#main-cart-footer .js-contents');
        if (mf && hf != null) mf.innerHTML = hf;
        var empty = c.item_count === 0, ci = $('cart-items'), foot = document.getElementById('main-cart-footer');
        if (ci) ci.classList.toggle('is-empty', empty);
        if (foot) foot.classList.toggle('is-empty', empty);
        ['cart-icon-bubble', 'cart-live-region-text'].forEach(function (id) {
          var el = document.getElementById(id);
          if (!el || !S[id]) return;
          var tgt = el.querySelector('.shopify-section') || el, h = innerOf(S[id], '.shopify-section');
          if (h != null) tgt.innerHTML = h;
        });
      })
      .catch(function () { return renderPage(); });
  }

  /* ---------- transaction queue ---------- */
  var targs = {}, chain = Promise.resolve(), depth = 0, lastSig = null, known = null, want = {}, timers = {}, errAfter = null;
  function fmt(cents) { return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; }
  function unitOf(r) {
    var u = $('.mc-unit', r), m = u && u.textContent.match(/[\d.]+,\d{2}/);
    return m ? Math.round(parseFloat(m[0].replace(/\./g, '').replace(',', '.')) * 100) : null;
  }
  /* a row whose price is simply unit x quantity (no deal, no line discount) */
  function isSimple(r) {
    return !r.hasAttribute('data-mc-gift') && !r.hasAttribute('data-mc-deal') && !r.querySelector('.cart-item__discounted-prices,.mc-tag,.discounts li') && unitOf(r) != null;
  }
  function markSimple() { $$('#main-cart-items tr.mc-row').forEach(function (r) { r.classList.toggle('mc-simple', isSimple(r)); }); }
  /* optimistic subtotal: exact when every paid row is a plain row and gifts are free */
  function optSubtotal() {
    markSimple();
    var rows = $$('#main-cart-items tr.mc-row'), sum = 0, cnt = 0, ok = rows.length > 0;
    rows.forEach(function (r) {
      var gk = r.getAttribute('data-mc-gk'), q = gk in want ? want[gk] : +r.dataset.mcQty;
      if (r.hasAttribute('data-mc-gift')) { if (!$('.mc-free', r)) ok = false; cnt += q; return; }
      if (!r.classList.contains('mc-simple')) { ok = false; return; }
      sum += unitOf(r) * q; cnt += q;
    });
    var row = $('#main-cart-footer .mc-sum__row');
    if (!row) return;
    if (!ok) { row.classList.remove('mc-opt'); return; }
    var sp = row.querySelectorAll('span');
    if (sp.length >= 2) {
      sp[sp.length - 1].textContent = fmt(sum);
      sp[0].textContent = sp[0].textContent.replace(/\(\d+/, '(' + cnt);
      row.classList.add('mc-opt');
    }
  }
  function busy(on) {
    if (on) markSimple();
    var ci = $('cart-items'), f = document.getElementById('main-cart-footer');
    if (ci) ci.classList.toggle('mc-busy', on);
    if (f) f.classList.toggle('mc-busy-foot', on);
  }
  /* Sepet kayması (2026-10-21): silme ve temizlemede görüntü dokunuş anında değişir, sunucu cevabını beklemez; hata olursa run() sepeti gerçek hâliyle yeniden çizer. Geri alma: emptyNow/removeNow ve iki çağrısını silin, modalco-cro.css 11-i satırını kaldırın. */
  function emptyNow() {
    var ci = $('cart-items'), f = document.getElementById('main-cart-footer'), h = $('.cart__empty-text');
    if (ci) ci.classList.add('is-empty');
    if (f) f.classList.add('is-empty');
    try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, 0); }
    if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  }
  function removeNow(r, gift) {
    var rs = $$('#main-cart-items tr[data-mc-gk]:not(.mc-removing)'), i = rs.indexOf(r), nx = rs[i + 1] || rs[i - 1], fb = nx && $('.mc-qty__del', nx);
    r.classList.add('mc-removing');
    if (fb && r.contains(document.activeElement)) fb.focus({ preventScroll: true });
    if (!gift && !$$('#main-cart-items tr[data-mc-gk]:not([data-mc-gift]):not(.mc-removing)').length) emptyNow();
  }
  function rowByGk(gk) {
    return $$('#main-cart-items tr[data-mc-gk]').filter(function (r) { return r.getAttribute('data-mc-gk') === gk; })[0];
  }
  function paintWanted() {
    Object.keys(want).forEach(function (gk) {
      var r = rowByGk(gk);
      if (r) paintRow(r, want[gk]);
    });
  }
  function paintRow(r, n) {
    var sp = $('.mc-qty__n', r);
    if (sp) sp.textContent = n;
    var max = r.dataset.mcMax ? +r.dataset.mcMax : Infinity;
    $$('.mc-qty__btn', r).forEach(function (b) {
      var d = +b.getAttribute('data-d');
      b.disabled = d < 0 ? n <= 1 : n >= max;
    });
    if (n !== +r.dataset.mcQty) r.classList.add('mc-pend');
    else r.classList.remove('mc-pend');
    /* instant, exact line price for plain rows */
    r.classList.toggle('mc-simple', isSimple(r));
    if (r.classList.contains('mc-simple')) {
      var t = fmt(unitOf(r) * n);
      $$('.cart-item__price-wrapper', r).forEach(function (w) { w.innerHTML = '<span class="price price--end">' + t + '</span>'; });
    }
    optSubtotal();
  }
  function showErr() {
    if (!errAfter) return;
    var r = errAfter.gk ? rowByGk(errAfter.gk) : null, box = r && $('.mc-row__err', r);
    if (box) { box.textContent = errAfter.msg; box.hidden = false; }
    else {
      var live = document.getElementById('cart-live-region-text');
      if (live) live.textContent = errAfter.msg;
    }
    errAfter = null;
  }
  function publish(c) {
    try {
      var E = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS) || window.PUB_SUB_EVENTS, Pb = (typeof window.publish === 'function') ? window.publish : null;
      if (E && Pb) Pb(E.cartUpdate, { source: 'cart-items', cartData: c });
    } catch (e) {}
  }
  /* network is down / Shopify unreachable: never auto-reload (would loop on slow mobile), offer a manual retry */
  function softFail() {
    if ($('.mc-soft')) return;
    var host = document.getElementById('main-cart-items');
    if (!host) return;
    var b = document.createElement('div');
    b.className = 'mc-soft'; b.setAttribute('role', 'alert');
    b.innerHTML = '<span>' + (EN ? 'We could not refresh your cart. Check your connection.' : 'Sepet güncellenemedi, bağlantını kontrol et.') + '</span> <button type="button">' + (EN ? 'Reload' : 'Yenile') + '</button>';
    b.querySelector('button').addEventListener('click', function () { location.reload(); });
    host.insertBefore(b, host.firstChild);
  }
  function ladder(c) { try { window.mcPlaceLadder && window.mcPlaceLadder(c); } catch (e) {} }

  function run(job, o) {
    var mutated = false, jr = null, giftChanged = false;
    return Promise.resolve()
      .then(function () {
        if (!job) return null;
        return Promise.resolve(job()).then(function (r) {
          if (r === false) return null;
          mutated = true;
          jr = r && r.items ? { cart: r } : (r && r.cart ? r : null);
          return null;
        });
      })
      .then(function () { return jr && jr.cart && jr.cart.items ? norm(jr.cart) : getCart(o.fresh); })
      .then(function (c) {
        if (lastSig === null && !mutated) lastSig = sig(c);
        var s0 = sig(c);
        var gs = Promise.resolve(window.mcGiftSync ? window.mcGiftSync(c) : c);
        var gt = new Promise(function (res) { setTimeout(function () { res(null); }, 9000); });
        return Promise.race([gs, gt]).then(function (c2) { return c2 || getCart(true); }).then(function (c2) {
          giftChanged = sig(c2) !== s0;
          return c2;
        });
      })
      .then(function (c) {
        if (o._ep !== epoch) return c; /* superseded by a reset: do not touch the page */
        known = c;
        var s = sig(c);
        if (!o.force && s === lastSig) { ladder(c); return c; }
        var pre = giftChanged ? (c.sections || null) : (jr && jr.cart && jr.cart.sections ? jr.cart.sections : null);
        return render(c, pre).then(function () {
          var sb = $('.mc-soft'); if (sb && sb.parentNode) sb.parentNode.removeChild(sb);
          lastSig = s;
          ladder(c);
          publish(c);
          return c;
        });
      })
      .catch(function (e) {
        if (o._ep !== epoch) return null;
        errAfter = { gk: o.gk, msg: e && e.status === 422 ? (e.message && e.message.length < 180 ? e.message : T.stock) : T.err };
        if (o.gk) delete want[o.gk];
        known = null;
        return getCart(true).then(function (c) {
          known = c;
          return render(c).then(function () { lastSig = sig(c); ladder(c); return c; });
        }).catch(function () { softFail(); return null; });
      })
      .then(function (c) {
        if (o._ep !== epoch) return c;
        paintWanted();
        showErr();
        return c;
      });
  }
  var epoch = 0, txStart = 0;
  function tx(job, o) {
    o = o || {};
    var my = epoch;
    o._ep = my;
    depth++;
    window.__mcTx = true;
    busy(true);
    var p = chain.then(function () {
      if (my !== epoch) return null;
      txStart = Date.now();
      /* watchdog: a transaction can never hold the cart for more than 20 s */
      var wd = new Promise(function (_, rej) { setTimeout(function () { var e = new Error('watchdog'); e.watchdog = true; rej(e); }, 20000); });
      return Promise.race([run(job, o), wd]);
    });
    chain = p.catch(function (e) {
      if (e && e.watchdog) setTimeout(function () { resetTx(); }, 0);
    }).then(function () {
      if (my !== epoch) return;
      depth--;
      txStart = 0;
      if (depth <= 0) { depth = 0; window.__mcTx = false; busy(false); }
    });
    return p;
  }
  /* hard reset: drop anything in flight, unlock and re-read the real cart */
  function resetTx() {
    epoch++;
    chain = Promise.resolve();
    depth = 0;
    txStart = 0;
    want = {};
    Object.keys(timers).forEach(function (k) { clearTimeout(timers[k]); });
    timers = {};
    known = null;
    window.__mcTx = false;
    busy(false);
    $$('.mc-row.mc-pend,.mc-row.mc-removing').forEach(function (r) { r.classList.remove('mc-pend', 'mc-removing'); });
    tx(null, { force: true, fresh: true });
  }
  /* back/forward cache restore or returning to a frozen tab: never trust in-flight state */
  window.addEventListener('pageshow', function (e) { if (e.persisted) resetTx(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    if (txStart && Date.now() - txStart > 8000) resetTx();
    else if (!depth) tx(null, { fresh: true }); /* another tab may have changed the cart */
  });
  window.mcCartTx = tx;
  window.mcCartSecs = secList;
  window.mcCartPending = function () { return depth > 0 || Object.keys(timers).length > 0; };
  window.mcCartFlush = function () { Object.keys(timers).forEach(function (k) { var a = targs[k]; clearTimeout(timers[k]); delete timers[k]; if (a) commit.apply(null, a); }); };
  window.mcCartRerender = function () { return tx(null, { force: true }); };

  /* ---------- quantity changes ---------- */
  function commit(gk, vid, gift, key) {
    clearTimeout(timers[gk]);
    delete timers[gk];
    return tx(function () {
      if (!(gk in want)) return false;
      var n = want[gk];
      function done() { if (!timers[gk] && want[gk] === n) delete want[gk]; }
      function mine(c) {
        return c.items.filter(function (it) {
          if (key) return it.key === key;
          return it.variant_id === vid && isGift(it) === gift && !visibleProps(it) && !it.selling_plan_allocation && !it.parent_relationship;
        });
      }
      function qty(ls) { return ls.reduce(function (a, it) { return a + it.quantity; }, 0); }
      function post(c) {
        var lines = mine(c);
        if (!lines.length) return Promise.resolve(false);
        var cur = qty(lines);
        if (cur === n) return Promise.resolve(false);
        var u = {};
        var first = true;
        lines.forEach(function (it) { if (it.key in u) return; u[it.key] = first ? n : 0; first = false; });
        return J('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates: u, sections: secList().join(','), sections_url: P }) })
          .then(function (res) { return { cart: res, cur: cur }; });
      }
      /* quantities are absolute, so retrying a stalled request once is safe */
      function postRetry(c) {
        return post(c).catch(function (e) {
          if (!(e && (e.timeout || e.name === 'AbortError' || e.status === 429 || !e.status))) throw e;
          return new Promise(function (r) { setTimeout(r, e.status === 429 ? 900 : 150); }).then(function () { return getCart(true); }).then(post);
        });
      }
      var first = known ? Promise.resolve(known) : getCart();
      return first.then(postRetry).then(function (r) {
        /* our cached cart may be stale (e.g. changed in another tab): verify and retry once with a fresh cart */
        if (r && qty(mine(r.cart)) === n) return r;
        if (r === false && known) return getCart(true).then(post);
        if (r === false) return false;
        return getCart(true).then(function (c) { return qty(mine(c)) === n ? { cart: c } : post(c); });
      }).then(function (r) {
        done();
        if (!r) return false;
        if (n > 0 && qty(mine(r.cart)) < n) errAfter = { gk: gk, msg: T.stock };
        return r.cart;
      });
    }, { gk: gk });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var readd = t.closest('[data-mc-gift-readd]');
    if (readd) {
      e.preventDefault();
      try { window.mcGiftOptOut && window.mcGiftOptOut(false); } catch (er) {}
      tx(null);
      return;
    }

    var band = t.closest('[data-mc-gift-band]');
    if (band) {
      e.preventDefault();
      try { window.mcGiftBandOk && window.mcGiftBandOk(true); } catch (er) {}
      tx(null);
      return;
    }

    var b = t.closest('.mc-qty button');
    if (b) {
      var r = b.closest('tr[data-mc-gk]');
      if (!r || b.disabled) return;
      e.preventDefault();
      var gk = r.getAttribute('data-mc-gk'), vid = +r.dataset.mcVid, gift = r.hasAttribute('data-mc-gift'), key = r.dataset.mcKey || null;
      var err = $('.mc-row__err', r);
      if (err) err.hidden = true;
      if (b.classList.contains('mc-qty__del')) {
        if (gift && window.mcGiftOptOut) window.mcGiftOptOut(true);
        want[gk] = 0;
        removeNow(r, gift);
        optSubtotal();
        commit(gk, vid, gift, key);
        return;
      }
      var cur = gk in want ? want[gk] : +r.dataset.mcQty;
      var max = r.dataset.mcMax ? +r.dataset.mcMax : Infinity;
      var n = Math.max(1, Math.min(max, cur + (+b.getAttribute('data-d'))));
      if (n === cur) return;
      want[gk] = n;
      paintRow(r, n);
      clearTimeout(timers[gk]);
      targs[gk] = [gk, vid, gift, key];
      timers[gk] = setTimeout(function () { commit(gk, vid, gift, key); }, 170);
      return;
    }

    /* clear cart */
    var box = t.closest('.mc-clear');
    if (box) {
      var ask = $('.mc-clear__ask', box), btn = $('.mc-clear__btn', box);
      if (t.closest('.mc-clear__btn')) { btn.hidden = true; ask.hidden = false; $('.mc-clear__no', box).focus(); }
      else if (t.closest('.mc-clear__no')) { ask.hidden = true; btn.hidden = false; btn.focus(); }
      else if (t.closest('.mc-clear__yes')) {
        $('.mc-clear__yes', box).disabled = true; emptyNow();
        want = {};
        try { window.mcGiftOptOut && window.mcGiftOptOut(false); window.mcGiftBandOk && window.mcGiftBandOk(false); } catch (er) {}
        tx(function () { return J('/cart/clear.js', { method: 'POST', body: JSON.stringify({ sections: secList().join(','), sections_url: P }) }); }).then(function (c) {
          if (c && c.item_count === 0) { try { window.gtag && window.gtag('event', 'clear_cart'); } catch (er) {} }
          else { var y = $('.mc-clear__yes'); if (y) y.disabled = false; }
        });
      }
    }
  }, true);

  /* ---------- clear-cart link ---------- */
  function rowCount() { return $$('#main-cart-items tr[data-mc-gk]').length; }
  function mountClear() {
    var host = document.getElementById('main-cart-items'), old = $('.mc-clear');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    if (!host || rowCount() < 2) return;
    var w = document.createElement('div');
    w.className = 'mc-clear';
    w.innerHTML = '<button type="button" class="mc-clear__btn">' + ICON + '<span>' + T.clear + '</span></button><div class="mc-clear__ask" role="group" hidden><span>' + T.ask + '</span><button type="button" class="mc-clear__no">' + T.no + '</button><button type="button" class="mc-clear__yes">' + T.yes + '</button></div>';
    host.appendChild(w);
  }
  function start() {
    var sg = $('#main-cart-items [data-mc-sig]');
    if (sg && lastSig === null) lastSig = sg.getAttribute('data-mc-sig');
    mountClear();
    var host = document.getElementById('main-cart-items');
    if (host) new MutationObserver(function () {
      var has = !!$('.mc-clear');
      if ((rowCount() >= 2) !== has) mountClear();
    }).observe(host, { childList: true, subtree: true });
    tx(null);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
